import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmPopupComponent } from '@macs-frontend/features/shared';
import { ConfirmData } from '@macs-frontend/features/shared/components/confirm-popup/confirm-popup.component';
import {
  ModalWindowComponent,
  ModalWindowData,
} from '@macs-frontend/features/shared/components/modal-window/modal-window.component';
import {
  PromptData,
  PromptPopupComponent,
} from '@macs-frontend/features/shared/components/prompt-popup/prompt-popup.component';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class PopupService {
  constructor(private dialog: MatDialog) {}

  confirm(
    title = 'Are you sure?',
    description?: string,
    cancelBtn: string = 'Cancel',
    confirmBtn: string = 'Ok',
  ) {
    const afterClosed = this.dialog
      .open<ConfirmPopupComponent, ConfirmData<boolean>, boolean>(ConfirmPopupComponent, {
        data: {
          title,
          description,
          cancelBtn,
          confirmBtn,
          closeOnConfirm: true,
        },
      })
      .afterClosed()
      .pipe(map(result => result));

    /**
     * workaround for the following issue:
     * popup isn't opened correctly from callback
     */
    document.body.click();

    return afterClosed;
  }

  prompt(
    title?: string | null,
    description?: string | null,
    defaultValue: string = '',
    cancelBtn: string = 'Cancel',
    confirmBtn: string = 'Ok',
    otherOptions: {
      messageRequired?: boolean;
      placeholder?: string;
    } = {
      messageRequired: true,
      placeholder: '',
    },
  ) {
    return this.dialog
      .open<PromptPopupComponent, PromptData<string>, string | false>(
        PromptPopupComponent,
        {
          data: {
            title,
            description,
            cancelBtn,
            confirmBtn,
            closeOnConfirm: true,
            defaultMessage: defaultValue,
            messageRequired:
              'messageRequired' in otherOptions ? otherOptions.messageRequired : true,
            placeholder: 'placeholder' in otherOptions ? otherOptions.placeholder : '',
          },
        },
      )
      .afterClosed();
  }

  alert(
    title: string,
    description: string = '',
    error = false,
    modalWindowData?: Partial<ModalWindowData>,
  ) {
    return this.dialog
      .open(ModalWindowComponent, {
        data: {
          ...modalWindowData,
          title,
          description,
          error,
        } as ModalWindowData,
      })
      .afterClosed();
  }
}
